<template>
  <div class="fts-control-modal">
    <!-- Information Modal -->
    <modal
      class="fts-v-modal"
      :height="'auto'"
      :width="'800px'"
      :scrollable="true"
      :adaptive="true"
      @before-open="beforeOpen"
      @before-close="beforeClose"
      :name="'controlModal' + modalNameId"
    >
      <div class="fts-v-modal-header">
        <div class="fts-v-modal-header-title">
          {{formData.displayName? formData.displayName : 'Enter Name'}}
        </div>
      </div>

      <div class="fts-v-modal-content">
        <div class="fts-v-modal-content-body">
          <fts-form :form-data="formData" :form="form"></fts-form>

          <div class="fts-form-group" v-if="formData.input == 'button' && beta">   
            <fts-script-editor
              editor-id="buttonFrontEndScript"
              v-model="formData.frontendScript"
              lang="javascript"
              label="Frontend Script"
              disabled-dictionary
            >
              <template #label="{ label }">
                {{label}} <fts-release-badge class="fts-align-top" />
              </template>
            </fts-script-editor>
          </div>

          <template v-if="formData.input == 'button'">
            <fts-form-element
              :form-data="formData"
              :item="{
                'fieldName': 'eventName',
                'displayName': 'Event Name',
                'type': 0
              }"
            />

            <fts-form-element
              :form-data="formData"
              :item="{
                'fieldName': 'actionType',
                'icon': 'fts-icon-menu-caret-down'
              }"
            >
              <fts-select
                slot="formElement"
                slot-scope="{formData, item}"
                :form-data="formData"
                :item="item"
                :options="[
                  { id: 'event', name: 'Event' },
                  { id: 'goToUrl', name: 'Go To URL' },
                  { id: 'customPage', name: 'Custom Page' }
                ]"
              />
            </fts-form-element>

            <fts-form-element
              :form-data="formData"
              :item="{
                'fieldName': 'actionUrl',
                'displayName': 'Action URL',
                'type': 33
              }"
              v-if="
                formData.actionType === 'goToUrl' ||
                formData.actionType === 'customPage'
              "
            />
          </template>

          <fts-form-element
            :form-data="formData"
            :item="{
              fieldName: 'qrScan',
              displayName: 'QR Scan (mobile only)',
              type: 1
            }"
            v-if="formData.type == 0"
          />

          <template v-if="formData.custom">
            <!-- location:autocomplete -->
            <fts-form-element 
              :form-data="formData"
              :item="{
                fieldName: 'autocomplete',
                type: 1
              }"
              v-if="formData.type == 9"
            />
          </template>

          <fts-form-element
            :form-data="formData"
            :item="{
              fieldName: 'detectOnly',
              type: 1
            }"
            v-if="isInternal && formData.type == 9"
          >
            <template #formLabel="{ label }">
              {{label}} <fts-release-badge alpha class="fts-align-top" />
            </template>
          </fts-form-element>

          <fts-form-element
            :form-data="formData"
            :item="{
              fieldName: 'dateValidate',
              icon: 'fts-icon-menu-caret-down'
            }"
            v-if="
              isInternal && 
              (formData.type == 5 || formData.type == 6) && 
              formData.predefinedFormatId != 't'
            "
          >
            <template #formLabel="{ label }">
              {{label}} <fts-release-badge alpha class="fts-align-top" />
            </template>
            <fts-select
              slot="formElement"
              slot-scope="{formData, item}"
              :form-data="formData"
              :item="item"
              :options="[
                { id: 'none', name: 'None' },
                { id: 'futureDates', name: 'Future dates' },
                { id: 'pastDates', name: 'Past dates' },
                { id: 'within1YearsFutureAndPast', name: 'Within 1 years (future and past)' }
              ]"
            />
          </fts-form-element>

          <template v-if="beta">
            <!-- filter form data-->   
            <fts-form-element
              :form-data="formData"
              :item="{
                fieldName: 'autoCompleteFormDataFields',
                displayName: 'Filter Form Data',
                type: 0
              }"
            >
              <template #formLabel="{ label }">
                {{label}} <fts-release-badge class="fts-align-top" />
              </template>
            </fts-form-element>
            <!-- checkbox label -->
            <fts-form-element
              :form-data="formData"
              :item="{
                fieldName: 'checkboxLabel',
                type: 0
              }"
              v-if="isInternal && formData.type == 1"
            >
              <template #formLabel="{ label }">
                {{label}} <fts-release-badge alpha class="fts-align-top" />
              </template>
            </fts-form-element>
            <!-- script only -->
            <fts-form-element
              :form-data="formData"
              :item="{
                fieldName: 'scriptOnly',
                type: 1,
              }"
              v-if="[7, 8, 20, 21].indexOf(formData.type) > -1"
            >
              <template #formLabel="{ label }">
                {{label}} <fts-release-badge class="fts-align-top" />
              </template>
            </fts-form-element>
            <!-- query script -->
            <div class="fts-form-group" v-if="[7, 8, 20, 21].indexOf(formData.type) > -1">
              <fts-script-editor
                editor-id="queryScript"
                v-model="formData.queryScript"
                lang="python"
                label="Query Script"
              >
                <template #label="{ label }">
                  {{label}} <fts-release-badge class="fts-align-top" />
                </template>
              </fts-script-editor>
            </div>
          </template>
          
          <template v-if="[7, 8, 20, 21].indexOf(formData.type) > -1">
            <!-- sort -->
            <div class="fts-form-group">
              <fts-form-label placement="top">Sort</fts-form-label>
              <fts-sort
                :modules="modules"
                strategy-fixed
                placement="bottom-start"
                :fields="sortSelection"
                v-model="formData.sort"
              />
            </div>
            <!-- filter -->
            <div class="fts-form-group">
              <fts-form-label placement="top">Filter</fts-form-label>
              <fts-query-designer
                :modules="modules"
                :states="moduleStates"
                :variables="variables"
                :informationSource="selection"
                :filter="formData.filter"
                :mode="isDevelopment ? 'formula' : null"
              />
            </div>
          </template>

          <!-- simple table -->
          <fts-form-element
            :form-data="formData"
            :item="{
              fieldName: 'simpleMode',
              type: 1
            }"
            v-if="beta && formData.type == 14"
          >
            <template #formLabel="{ label }">
              {{label}} <fts-release-badge beta class="fts-align-top" />
            </template>
          </fts-form-element>

          <div v-if="formData.type == 15">
            <div>List</div>
            <fts-form :formData="formData" :form="{ 'rows': [{ 'items': [{ 'fieldName': 'displayField', 'displayName': 'Display Field' }]}] }"></fts-form>
          </div>

          <!-- Temp disable due to fields and columns issues formData.type === 14 || formData.type === 15 -->
          <div v-if="false" class="class-info">
            <div class="content-body-main-label">Fields</div>
            <!-- Classification -->
            <div class="classification-container">
              <div class="classification-information" v-if="formData.fields">
                <draggable
                  v-model="formData.fields"
                  v-bind="dragOptions"
                  handle=".class-info-handle"
                  class="class-info-container"
                >
                  <div
                    v-for="(classInfo, index) in formData.columns"
                    :key="classInfo.information.id"
                    :class="{ 'over': show == index }"
                    @mouseover="show = index"
                    @mouseleave="show = -1"
                    class="class-info-wrapper"
                  >
                    <div class="class-info-inner-wrapper">
                      <div class="class-info-item">
                        <div class="class-info-item-wrapper">
                          <font-awesome-icon
                            :icon="['fas', 'grip-vertical']"
                            fixed-width
                            class="class-info-handle"
                            @click.stop
                          />
                          <i class="class-info-icon" :class="getIcon(classInfo.information.type)"></i>
                          <div
                            class="class-info-display-name"
                            @click="showInformation(classInfo.information)"
                          >{{classInfo.information.displayName}}</div>
                          <span class="fts-badge-legacy" v-if="classInfo.required">Required</span>
                          <span class="fts-badge-legacy" v-if="classInfo.readOnly">Read Only</span>
                          <span class="fts-badge-legacy" v-if="classInfo.due">Due</span>
                          <span class="fts-badge-legacy" v-if="classInfo.assignee">Assignee</span>
                          <span
                            class="fts-badge-legacy"
                            v-if="classInfo.addRemoveItems"
                          >Add/Remove Items</span>
                        </div>
                      </div>
                    </div>

                    <div class="class-info-additional-action" v-if="show === index">
                      <span
                        class="fts-badge-legacy"
                        :class="{'active': classInfo.required}"
                        @click.stop="classInfo.required = !classInfo.required"
                      >Required</span>
                      <span
                        class="fts-badge-legacy"
                        :class="{'active': classInfo.readOnly}"
                        @click.stop="classInfo.readOnly = !classInfo.readOnly"
                      >Read only</span>

                      <!-- Visibility Script -->
                      <font-awesome-icon :icon="['far', 'eye']" fixed-width class="edit-action" />
                      <font-awesome-icon
                        :icon="['fas', 'cog']"
                        fixed-width
                        class="edit-action"
                        @click="showInformation(classInfo.information)"
                      />
                      <font-awesome-icon
                        :icon="['fas', 'times']"
                        fixed-width
                        class="remove-action"
                        @click.stop="modalConfirmation('removeInformation', classInfo)"
                      />
                    </div>
                  </div>
                </draggable>
              </div>
            </div>

            <div class="class-info-action">
              <input
                class="fet-form-control"
                v-model="newInformation.displayName"
                :placeholder="'create field'"
                taggable
                label="displayName"
                :options="information"
              />
              <v-select
                v-model="newInformation.typeModel"
                :key-property="'id'"
                @keyUpdate="newInformation.type = $event"
                label="type"
                :text="newInformation && newInformation.typeModel? newInformation.typeModel.type : ''"
                :options="informationTypes"
              ></v-select>
              <button
                type="button"
                class="fts-btn fts-btn-outline fts-btn-primary fts-btn-icon-mr"
                @click="addInformation()"
              >
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width />Add
              </button>
            </div>
          </div>
          <!-- advanced -->
          <fts-collapsible-element v-model="advanced">
            <fts-btn
              slot="toggle"
              slot-scope="{ isVisible, toggle }"
              text
              text-transform-init
              :class="{ open: isVisible }"
              class="design-modal-advanced-toggle"
              @click="toggle()"
            >
              Advanced settings
              <font-awesome-icon
                :icon="['fas', 'caret-right']"
                class="design-modal-advanced-toggle-icon"
              />
            </fts-btn>
            <div slot="content" class="fts-row gutters">
              <!-- field name -->
              <fts-form-element
                :form-data="formData"
                :item="{
                  fieldName: 'fieldName',
                  type: 0,
                  readOnly: !this.formData.custom
                }"
                class="fts-col"
              />
              <template v-if="formData.type === 7 && isDevelopment">
                <div class="fts-col fts-form-group">
                  <fts-checkbox v-model="advancedTemplate">
                    Enable Advanced Template <fts-release-badge dev class="fts-align-top" />
                  </fts-checkbox>
                </div>
                <template v-if="advancedTemplate">
                  <fts-form-element
                    :form-data="formData.advancedTemplate"
                    :item="{
                      fieldName: 'id',
                      type: 0,
                    }"
                    class="fts-col"
                  />
                  <fts-form-element
                    :form-data="formData.advancedTemplate"
                    :item="{
                      fieldName: 'title',
                      displayName: 'Title (Information FieldName)',
                      type: 0,
                    }"
                    class="fts-col"
                  />
                  <fts-form-element
                    :form-data="formData.advancedTemplate"
                    :item="{
                      fieldName: 'titleId',
                      displayName: 'Title (Information ID)',
                      type: 0,
                    }"
                    class="fts-col"
                  />
                  <fts-form-element
                    :form-data="formData.advancedTemplate"
                    :item="{
                      fieldName: 'image',
                      displayName: 'Image (Information FieldName)',
                      type: 0,
                    }"
                    class="fts-col"
                  />
                  <fts-form-element
                    :form-data="formData.advancedTemplate"
                    :item="{
                      fieldName: 'imageId',
                      displayName: 'Image (Information ID)',
                      type: 0,
                    }"
                    class="fts-col"
                  />
                </template>
              </template>
            </div>
          </fts-collapsible-element>
        </div>

        <div class="fts-v-modal-content-footer">
          <div></div>
          <fts-btn outline color="primary" @click="close">
            <font-awesome-icon :icon="['fas', 'check']" /> Ok
          </fts-btn>
        </div>

        <font-awesome-icon
          :icon="['fas', 'times']"
          fixed-width
          class="close-action"
          @click="close"
        />
      </div>
    </modal>

    <FTSNestedInformationModal @delete="deleteNested" @confirm="confirmNested"></FTSNestedInformationModal>
  </div>
</template>

<script>
import Vue from "vue";
import draggable from "vuedraggable";
import vSelect from "../vue-select/index";

import commons from "../commons/commons";
import queryLogic from "../commons/queryLogic";
import { authorizationStore } from '../store/authorizationStore';

import FTSForm from "../elements/FTSForm";
import FTSFormLabel from "../elements/FTSFormLabel";
import FTSNestedInformationModal from "./FTSNestedInformationModal";
import FTSScriptEditor from "../design/FTSScriptEditor";
import FTSQueryDesigner from "./FTSQueryDesigner";
import FTSContenteditable from "../elements/FTSContenteditable";
import FTSSort from "../elements/FTSSort";
import FTSBtn from "../elements/FTSBtn";
import FTSCollapsibleElement from "../elements/FTSCollapsibleElement";
import FTSFormElement from "../elements/FTSFormElement";
import FTSSelect from "../elements/FTSSelect";
import FTSCheckbox from '../elements/FTSCheckbox';

export default {
  props: ["modalNameId"],
  data() {
    let vm = this;
    return {
      formData: {},
      formDesign: null,
      lookupSelection: [],
      dragOptions: commons.dragOptions,
      show: -1,
      newInformation: {},
      advanced: false,
      informationTypes: commons.informationTypes,
      form: {
        rows: [
          {
            items: [
              {
                displayName: "Name",
                fieldName: "displayName",
                input: "text",
                hiddenFunc: (formData) => !formData.custom,
              },
              {
                displayName: "Label (Optional)",
                fieldName: "label",
                input: "text",
              },
            ],
          },
          // {
          //   items: [
          //     {
          //       displayName: "Field Name",
          //       fieldName: "fieldName",
          //       input: "text",
          //     },
          //   ],
          // },
          {
            items: [
              {
                displayName: "Description",
                fieldName: "description",
                input: "textArea",
              },
            ],
          },
          {
            items: [
              {
                displayName: "Type",
                fieldName: "typeText",
                input: "dropDown",
                key: "type",
                displayProperty: "type",
                // FETIAS Issue SS00217, temp disabled
                optionList: commons.informationTypes.filter(
                  x => x.id !== 14 && x.id !== 15 && x.id !== 30
                ),
                // hiddenFunc: formData => this.hidden("type", formData)
              },
              {
                displayName: "Format",
                fieldName: "predefinedFormat",
                type: 0,
                readOnly: true,
                hiddenFunc: (formData) => this.hidden("formatDisplay", formData),
              },
              {
                displayName: 'Enable Custom Format',
                fieldName: 'enableCustomDateFormat',
                type: 1,
                hiddenFunc: (formData) => this.hidden("formatDisplay", formData),
              },
              {
                displayName: "Custom Format",
                fieldName: "customDateFormat",
                type: 27,
                optionList: commons.dateFormats,
                optionColor: false,
                hiddenFunc: (formData) => this.hidden("customDateFormat", formData),
              },
              {
                displayName: "Format",
                fieldName: "predefinedFormat",
                input: "dropDown",
                optionList: commons.dateFormats,
                hiddenFunc: (formData) => this.hidden("format", formData),
              },
            ],
          },
          {
            items: [
              {
                displayName: "Prefix (beta)",
                fieldName: "prefix",
                input: "text",
                hiddenFunc: (formData) => this.hidden("prefix", formData, true),
              },
            ],
          },
          {
            items: [
              {
                displayName: "With time (beta)",
                fieldName: "withTime",
                input: "boolean",
                hiddenFunc: (formData) => this.hidden("withTime", formData, true),
              },
            ],
          },
          {
            items: [
              {
                displayName: "Extra (Module)",
                fieldName: "connection",
                key: "connectionId",
                input: "dropDown",
                displayProperty: 'name',
                optionList: this.lookupSelection,
                hiddenFunc: (formData) => this.hidden("lookup", formData),
              },
              {
                displayName: "Information (Module's Information)",
                fieldName: "searchField",
                input: "dropDown",
                key: "searchFieldId",
                displayProperty: "displayName",
                /* SS05695: declared so that every later assignment is reactive. The list is
                   filled from moduleInformation, which stays empty until loadVectorSelection
                   answers; added by a plain assignment instead, the property was never
                   observed, and a menu opened before that answer stayed empty on reopen. */
                optionList: [],
                hiddenFunc: (formData) => this.hidden("searchField", formData),
              },
            ],
          },
          // {
          //   items: [
          //     {
          //       displayName: "Connection ID",
          //       fieldName: "connectionId",
          //       input: "integer",
          //       readOnly: true,
          //       hiddenFunc: (formData) => this.hidden("connectionId", formData),
          //     },
          //     {
          //       displayName: "Preload",
          //       fieldName: "test",
          //       input: "boolean",
          //       hiddenFunc: (formData) => this.hidden("lookup", formData),
          //     },
          //   ],
          // },
          {
            items: [
              {
                displayName: "Allow multiple (beta)",
                fieldName: "allowMultiple",
                input: "boolean",
                hiddenFunc: (formData) =>
                  this.hidden("allowMultiple", formData, true),
              },
            ],
          },
          {
            items: [
              {
                displayName: "Options",
                fieldName: "optionList",
                input: "table",
                type: 14,
                readOnly: true,
                fields: [
                  {
                    displayName: "Name",
                    fieldName: "name",
                    type: 0,
                  },
                  {
                    fieldName: "color",
                    displayName: "Color",
                    type: 0,
                  },
                ],
                addRemoveItems: true,
                hiddenFunc: (formData) => this.hidden("optionsDisplay", formData), 
              },
              {
                displayName: "Options",
                fieldName: "optionList",
                input: "table",
                type: 14,
                fields: [
                  {
                    displayName: "Name",
                    fieldName: "name",
                    type: "text",
                  },
                  {
                    fieldName: "color",
                    displayName: "Color",
                    type: "text",
                  },
                ],
                addRemoveItems: true,
                hiddenFunc: (formData) => this.hidden("options", formData),
              },
            ],
          },
          {
            items: [
              {
                displayName: "Column Width",
                fieldName: "columnWidth",
                input: "integer",
                hiddenFunc: (formData) => this.hidden('columnWidth', formData),
              },
            ],
          },
          {
            items: [
              {
                displayName: "Decimal Places",
                fieldName: "decimalPlaces",
                input: "integer",
                hiddenFunc: (formData) => this.hidden('decimalPlaces', formData),
              },
            ],
          },
        ],
      },
    };
  },
  components: {
    draggable,
    "fts-form": FTSForm,
    "fts-form-label": FTSFormLabel,
    "fts-sort": FTSSort,
    "v-select": vSelect,
    FTSNestedInformationModal,
    "fts-script-editor": FTSScriptEditor,
    "fts-query-designer": FTSQueryDesigner,
    "fts-contenteditable": FTSContenteditable,
    "fts-btn": FTSBtn,
    "fts-collapsible-element": FTSCollapsibleElement,
    "fts-form-element": FTSFormElement,
    "fts-select": FTSSelect,
    "fts-checkbox": FTSCheckbox
  },
  methods: {
    beforeOpen(event) {
      let payload = event.params;
      if (payload.formData) {
        this.formData = payload.formData;
        /* set type */
        if (this.formData.type === null || this.formData.type === undefined)
          this.$set(this.formData, "type", 0);
        /* set field name */
        if (!this.formData.fieldName)
          this.$set(this.formData, "fieldName", commons.generateFieldName())
        /* set predefined format (date) */
        if ((this.formData.type == 5 || this.formData.type == 6) && this.formData.predefinedFormatId) {
          const predefinedFormat = commons.dateFormats.find(x => x.id === this.formData.predefinedFormatId);
          if (predefinedFormat)
            this.$set(this.formData, "predefinedFormat", predefinedFormat.name);
        }
      }

      if (payload.form) {
        this.formDesign = payload.form;
      }
    },
    beforeClose() {
      if (
        this.formData.custom && 
        [7, 8, 20, 21].indexOf(this.formData.type) > -1
      ) {
        if (this.formData.searchField) {
          this.formData.connectionField = this.formData.searchField;
          this.formData.connectionFieldId = this.formData.searchFieldId;
        } else {
          this.formData.connectionField = null;
          this.formData.connectionFieldId = null;
        }
      }

      Object.assign(this.$data, this.$options.data.apply(this));
    },
    hidden(type, formData, isBeta) {
      if (isBeta && !this.beta)
        return true

      if (
        type == "format" &&
        (formData.type == 5 || formData.type == 6) &&
        formData.custom
      ) {
        return false
      } else if (
        type == "customDateFormat" && 
        (formData.type == 5 || formData.type == 6) &&
        (!formData.custom && formData.enableCustomDateFormat)
      ) {
        return false;
      } else if (
        type == "formatDisplay" && 
        (formData.type == 5 || formData.type == 6) &&
        !formData.custom
      ) {
        return false;
      } else if (type == "withTime" && (formData.type == 5 || formData.type == 6)) {
        return false;
      } else if (type == "prefix" && formData.type == 4) {
        return false;
      } else if (
        type == "allowMultiple" &&
        [10, 12, 7, 20].some((y) => formData.type == y)
      ) {
        return false;
      } else if (
        type == "lookup" && 
        [7, 8, 20, 21].some((y) => formData.type == y) &&
        formData.custom
      ) {
        return false;
        // return !formData.custom;
        // if ([7, 8, 20].some((y) => formData.type == y)) return false;
      } else if (
        type == "searchField" &&
        [7, 8, 20, 21].some((y) => formData.type == y) &&
        formData.custom
      ) {
        return false;
        // return !formData.custom;
      } else if (
        type == "connectionId" &&
        [7, 8, 20, 21].some((y) => formData.type == y)
      ) {
        return false;
      } else if (type == "options" && formData.type == 27 && formData.custom) {
        return false;
      } else if (type == "optionsDisplay" && formData.type == 27 && !formData.custom) {
        return false;
      } else if (type == "type" && formData.custom) {
        return false;
      } else if (type == "columnWidth") {
        const tables = this.information.filter(x => x.type == 14) 
        return !tables.some(x => x.fields && Array.isArray(x.fields) && x.fields.some(y => y.id == formData.id))
      } else if (type == "decimalPlaces" && formData.type === 3) {
        return false
      }

      return true;
    },
    addInformation() {
      if (this.formData.fields == null) {
        this.formData.fields = [];
      }

      let informationField = _.cloneDeep(this.newInformation);
      informationField.id = commons.newUUID();
      delete informationField.typeModel;

      this.formData.fields.push({ information: informationField });
      // if (!this.newInformation.id) {
      //   this.$store.dispatch("confirmInformation", {
      //     information: this.newInformation
      //   });
      // }

      // this.activity.classification.push({
      //   id: commons.newUUID(),
      //   information: this.newInformation
      // });

      this.newInformation = {};
    },
    close() {
      this.advanced = false;
      this.$emit("ok", this.formData);
      this.$modal.hide("controlModal" + this.modalNameId);
    },
    deleteNested(nested) {
      this.formData.fields = this.formData.fields.filter(
        (x) => x.information.id != nested.id
      );
    },
    confirmNested(nested) {
      let field = this.formData.fields.find(
        (x) => x.information.id == nested.id
      );
      Object.assign(field.information, nested);
    },
  },
  watch: {
    /* SS05695: the Information list follows the module list and the chosen module, whichever
       arrives last - on reopen the chosen module is known before the module list is */
    moduleInformation(val) {
      this.form.rows[5].items[1].optionList = val;
    },
    "formData.connectionModel": function (val) {
      if (val) {
        let vm = this;
        vm.form.rows[5].items[1].optionList = val.information;
      }
    },
    "formData.connectionId": function (val, oldVal) {
      let vm = this;
      vm.form.rows[5].items[1].optionList = vm.moduleInformation;
      // reset searchField
      if (oldVal !== undefined) {
        vm.$set(vm.formData, "searchField", null);
      }
    },
    "formData.custom": function (val) {
      if (val) {
        let vm = this;
        this.$store.dispatch("loadVectorSelection").then(function (res) {
          vm.form.rows[5].items[0].optionList = res.data;
          vm.lookupSelection = res.data;
        });
      }
    },
    "formData.type": async function (val, oldVal) {
      if ([7, 8, 20, 21].indexOf(val) > -1) {
        if (!this.formData.filter) {
          Vue.set(this.formData, "filter", { items: [] });
        }

        try {
          let vm = this;
          const res = await this.$store.dispatch("loadVectorSelection");
          vm.form.rows[5].items[0].optionList = res.data;
          vm.lookupSelection = res.data;
          vm.form.rows[5].items[1].optionList = vm.moduleInformation;
        } catch(err) {
          console.error('Failed to loadVectorSelection', err);
        }
      }

      if (this.formData.type == 27 && !this.formData.optionList) {
        this.formData.optionList = [];
      }
    }
  },
  computed: {
    variables() {
      return [
        {
          name: "Form",
          fieldName: "form",
          type: 35,
          moduleId: this.$store.state.vectorId.toString(),
          activityId: this.activityId,
          form: this.formDesign,
        }
      ];
    },
    isDevelopment() {
      return authorizationStore.getters.isDevelopment;
    },
    isInternal() {
      return authorizationStore.getters.isInternal;
    },
    beta() {
      return authorizationStore.getters.isBeta || this.$store.getters.workspaceBeta;
    },
    information() {
      return this.$store.state.canvas.information;
    },
    modules() {
      return this.$store.getters.workspaceModules;
    },
    states() {
      return this.$store.state.canvas.states;
    },
    selection() {
      let differenceList = [];
      if (this.formData.type != 20) differenceList.push("username");
      if (this.moduleStates && !this.moduleStates.length) differenceList.push("state");
      return _.differenceWith(
        queryLogic.querySelectionPrefix,
        differenceList,
        ({ id }, key) => id === key
      ).concat(this.moduleInformation).concat(queryLogic.querySelectionSuffix);
    },
    sortSelection() {
      let differenceList = ["collaboration", "assignTo", "due", "createdBy", "lastChangeBy", "$DocumentId"];
      if (this.formData.type != 20) differenceList.push("username");
      if (this.moduleStates && !this.moduleStates.length) differenceList.push("state");
      return _.differenceWith(
        queryLogic.querySelectionPrefix,
        differenceList,
        ({ id }, key) => id === key
      ).concat(this.moduleInformation).filter(x => x.fieldName != '$DocumentId');
    },
    moduleInformation() {
      if (Array.isArray(this.lookupSelection) && this.formData.connectionId) {
        const findModule = this.lookupSelection.find(x => x.id == this.formData.connectionId);
        if (findModule && findModule.information)
          return findModule.information;
      }
      return [];
    },
    moduleStates() {
      if (Array.isArray(this.lookupSelection) && this.formData.connectionId) {
        const findModule = this.lookupSelection.find(x => x.id == this.formData.connectionId);
        if (findModule && findModule.states)
          return findModule.states;
      }
      return [];
    },
    advancedTemplate: {
      get() {
        return Boolean(this.formData.advancedTemplate);
      },
      set(val) {
        if (val) {
          this.$set(this.formData, "advancedTemplate", {'id': 'advanced-template-1'});
        } else {
          this.$delete(this.formData, "advancedTemplate");
        }
      }
    }
  },
  created() {
    if (this.formData.custom) {
      let vm = this;
      this.$store.dispatch("loadVectorSelection").then(function (res) {
        vm.form.rows[5].items[0].optionList = res.data;
        vm.lookupSelection = res.data;
        vm.form.rows[5].items[1].optionList = vm.moduleInformation;
      });
    }

    if ([7, 8, 20, 21].indexOf(this.formData.type) > -1) {
      this.formData.filter = { items: [] };
    }
  }
};
</script>

<style lang="scss">
@use "./src/assets/scss/colors" as *;

.fts-control-modal {
  > .fts-v-modal > .v--modal-background-click > .v--modal-box.v--modal{
    top: 55px !important;
  }
  .class-info {
    margin-bottom: 2rem;
    .class-info-label {
      font-size: 0.875rem;
      color: $grayLightColor;
      letter-spacing: 0.09em;
    }
    .class-info-wrapper {
      display: flex;
      flex-wrap: wrap;
      padding: 6px;
      &:hover {
        background: #eeeeee;
      }
      .class-info-inner-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .class-info-item {
          .class-info-display-name {
            display: flex;
            align-items: center;
            color: $darkColor;
            .class-info-icon {
              display: inline-flex;
              margin-right: 6px;
              color: var(--fts-secondary);
            }
          }
        }
        .class-info-setting {
          > svg {
            color: $grayLightColor;
            &.remove-action:hover {
              color: var(--fts-danger);
            }
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
    .class-info-action {
      display: flex;
      margin-top: 0.75rem;
      > input {
        margin-right: 6px;
        font-size: 0.875rem;
        max-width: 60%;
      }
      > .v-select {
        margin-right: 6px;
        flex: 1;
      }
    }
  }

  @media (min-width: 768px) {
    .fts-form-container .fts-form-item {
      .fts-form-element-container.compact-form-design .fts-form-label {
        min-width: 100px;
        width: 100px;
      }
    }
  }

  /* clone from FTSDesignModal */
  /* advanced toggle */
  .design-modal-advanced-toggle {
    margin-left: -0.75rem; 
    margin-bottom: 1rem;
    &.open {
      .design-modal-advanced-toggle-icon {
        transform: rotate(90deg);
      }
    }
    .design-modal-advanced-toggle-icon {
      margin-left: .75rem;
      margin-right: 0;
      transition: transform .3s;
    }
  }
}
</style>